var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-banner',{attrs:{"single-line":""},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-btn',{attrs:{"text":"","color":"deep-purple accent-4"}},[_vm._v(" Action ")])]},proxy:true}])},[_vm._v(" One line message text string with two actions on tablet / Desktop ")])
}
var staticRenderFns = []

export { render, staticRenderFns }